import { CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';

import ExcelIcon from '../../../../../assets/icons/ExcelIcon';
import PDFIcon from '../../../../../assets/icons/PDFIcon';
import SadIcon from '../../../../../assets/icons/SadIcon';
import WordIcon from '../../../../../assets/icons/WordIcon';
import Translations from '../../../../../assets/locale/en/content.json';
import { TngButton, TngGrid, TngTypography } from '../../../../common';

// this will render cell with 2 divs
export const CellWithMultipleValue = (props: any) => {
  const { value } = props;
  return (
    <TngGrid className="cell_value_render multiple_value_container">
      <TngTypography className="name"> {value.name}</TngTypography>
      <TngTypography className="type">{value.type}</TngTypography>
    </TngGrid>
  );
};

// this will render cell with link
export const CellWithlink = (props: any) => {
  const { value, data, navigateToRoute, navigateRouteParams } = props;
  const absoluteURL = new URL(navigateToRoute, window.location.origin);
  absoluteURL.searchParams.set(navigateRouteParams, data.orderId);

  return (
    value && (
      <Link
        to={absoluteURL.href}
        className="grid_cell_link cell_value_render"
        aria-label={`${props.column.colId} ${value}`}
      >
        {value}
      </Link>
    )
  );
};

// this will render cell with border
export const CellWithBorder = (props: any) => {
  const { value, statusColor } = props;
  const color = `#${statusColor[value as keyof typeof statusColor]}`;
  return (
    <TngGrid
      className="cell_with_border_container cell_value_render"
      style={{ border: `1px solid ${color}` }}
    >
      <TngTypography className="cell_value"> {value}</TngTypography>
    </TngGrid>
  );
};

// this will render when no data is present in grid
export const CustomNoRowsOverlay = ({
  isSearchedOrFiltered,
}: {
  isSearchedOrFiltered: boolean;
}) => {
  const renderedMessage = isSearchedOrFiltered
    ? Translations.TngGrid.noResultsFound
    : Translations.TngGrid.noListAvailable;

  return (
    <TngGrid className="custom_no_rows_overlay">
      <SadIcon height="42" width="42" />
      <TngTypography
        role="alert"
        aria-live="assertive"
        data-testid="no_results_message"
        className="custom_message"
      >
        {renderedMessage}
      </TngTypography>
    </TngGrid>
  );
};

// this will render loader
export const CustomLoadingOverlay: React.FC = () => {
  return (
    <TngGrid className="custom-loading-overlay" data-testid="grid_loader">
      <CircularProgress role="progressbar" />
    </TngGrid>
  );
};

// this will render tooltip tith data on value property
export const CustomTooltip = ({ value }: any) => {
  let tooltipContent;

  if (typeof value === 'object') {
    // Convert object to a pretty-printed JSON string
    tooltipContent = Object.values(value)
      .map((val) => `${val}`)
      .join('\n');
  } else {
    // Use the value as is if it's a string or any other type
    tooltipContent = value;
  }

  return <TngGrid className="grid-tooltip">{tooltipContent}</TngGrid>;
};

interface TextCellRendererProps {
  value: string | object;
}

// Custom cell renderer component
export const TextCellRenderer: React.FC<TextCellRendererProps> = (props) => {
  // eslint-disable-next-line react/prop-types
  const { value } = props;

  let formattedValue = '';
  if (value) {
    formattedValue =
      typeof value === 'object'
        ? Object.entries(value)
            .map(([key, val]) => `${key}: ${val}`)
            .join(', ')
        : value;
  }

  return (
    <TngGrid
      className="cell_value_render"
      aria-label={`${formattedValue ? formattedValue : Translations.TngGrid.dataNotAvailable}`}
    >
      {formattedValue}
    </TngGrid>
  );
};

export const CellWithDownloadAction = (props: any) => {
  const { id } = props.data;
  const download = () => {};
  const downloadFile = async (id: string) => {
    id && download();
  };
  return (
    <TngGrid className="cell_with_download_action">
      <TngButton className="download_button" onClick={() => downloadFile(id)}>
        Download
      </TngButton>
    </TngGrid>
  );
};

export const CellWithFileIcon = (props: any) => {
  const { value } = props;
  let renderedValue: string = '';

  const filterIcon = () => {
    switch (value) {
      case 'EXCEL_X':
        renderedValue = 'Spreadsheet file';
        return <ExcelIcon />;
      case 'PDF':
        renderedValue = 'Pdf file';
        return <PDFIcon />;
      case 'DOC':
        renderedValue = 'Word file';
        return <WordIcon />;
      default:
        return null;
    }
  };
  return (
    <TngGrid className="cell_with_File_Icon">
      {filterIcon()}
      <TngTypography component="span" variant="body1">
        {renderedValue}
      </TngTypography>
    </TngGrid>
  );
};
